import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=3dd4fd08&"
import script from "./ModalContent.vue?vue&type=script&lang=js&"
export * from "./ModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports